import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Output,
    Signal,
    ViewChild,
} from '@angular/core'

import { BookingHubSessionSettingsComponent } from '../booking-hub-session-settings/booking-hub-session-settings.component'
import { BookingHubScheduleFormComponent } from '../booking-hub-schedule-form/booking-hub-schedule-form.component'
import { NowSessionsSidebarComponent } from '@app/left-panel/components/now-sessions-sidebar/now-sessions-sidebar.component'
import { ScrollPanelModule } from 'primeng/scrollpanel'
import { ButtonModule } from 'primeng/button'
import { WelcomeChecklistService } from '@app/core/_services/welcome-checklist.service'
import { UserService } from '@app/core/_services/user.service'

import { Subject, takeUntil } from 'rxjs'
import { ViewportService } from '@app/core/_services/viewport.service'
import { UtilsService } from '@app/core/_services/utils.service'
import { FeatureCheckService } from '@app/core/_services'
import { TimeFormat, User } from '@app/core/_models'
import { TooltipModule } from 'primeng/tooltip'
import { faBolt, faClock } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
@Component({
    selector: 'fm-booking-hub',
    imports: [
        FontAwesomeModule,
        TooltipModule,
        ButtonModule,
        ScrollPanelModule,
        BookingHubScheduleFormComponent,
        BookingHubSessionSettingsComponent,
        NowSessionsSidebarComponent,
    ],
    templateUrl: './booking-hub.component.html',
    styleUrl: './booking-hub.component.scss',
})
export class BookingHubComponent {
    @ViewChild('container') container: ElementRef
    @ViewChild('focusNowButton', { read: ElementRef }) focusNowButton: ElementRef
    @ViewChild('scheduleButton', { read: ElementRef }) scheduleButton: ElementRef

    public faBolt = faBolt
    public faClock = faClock
    public showScheduleForm = false
    public showFocusNowForm = false
    public nowSessionsAvailable = false
    public settingsExpanded: boolean
    private ngUnsubscribe: Subject<any> = new Subject<any>()

    public isWelcomeChecklistActive: Signal<boolean> =
        this.welcomeChecklistService.isWelcomeChecklistActive

    private timeFormat: TimeFormat
    private timezone: string

    constructor(
        private userService: UserService,
        private welcomeChecklistService: WelcomeChecklistService,
        public viewportService: ViewportService,
        private utilsService: UtilsService,
        private featureCheckService: FeatureCheckService,
    ) {}

    ngOnInit(): void {
        this.userService.currentUser.pipe(takeUntil(this.ngUnsubscribe)).subscribe((user) => {
            this.nowSessionsAvailable = this.featureCheckService.canUseNowSessions(user)
            this.resetScheduleFormIfNeeded(user)
        })
    }

    resetScheduleFormIfNeeded(user: User): void {
        // If the user chooese to update their timezone or time format while the
        // scheduling form is open, close it so that the form can update the format
        if (this.timeFormat && this.timezone) {
            if (this.timeFormat !== user.settings.timeFormat || this.timezone !== user.timeZone) {
                this.onClickCloseScheduleForm()
            }
        }
        this.timezone = user.timeZone
        this.timeFormat = user.settings.timeFormat
    }

    onClickShowFocusNowForm() {
        this.utilsService.animateHeightChange(this.container.nativeElement, () => {
            this.showFocusNowForm = true
            this.showScheduleForm = false
        })
    }

    onClickShowScheduleForm() {
        this.utilsService.animateHeightChange(this.container.nativeElement, () => {
            this.showScheduleForm = true
            this.showFocusNowForm = false
        })
    }

    onClickCloseFocusNowForm() {
        this.utilsService.animateHeightChange(this.container.nativeElement, () => {
            this.showFocusNowForm = false
        })
    }

    onClickCloseScheduleForm() {
        this.utilsService.animateHeightChange(this.container.nativeElement, () => {
            this.showScheduleForm = false
        })
    }

    onSettingsExpandedToggle(setting: boolean): void {
        setTimeout(() => {
            this.settingsExpanded = setting
        })
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(null)
        this.ngUnsubscribe.complete()
    }
}
